/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPrescriptionBottle} from '@fortawesome/pro-duotone-svg-icons';

const MedicationIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faPrescriptionBottle} {...props} />
);

export default MedicationIcon;
